<template>
    <div class="reserva">
        <div class="container">
            <div class="row">
                <div class="col-md-8 bg-light shadow-md rounded">

                    <div class="bg-white reservation-form">
                        <b-form @submit.prevent="submit">
                            <div class="row card-header list-group-item-primary">
                                <h5 class="col-3">
                                    <i class="fas fa-list-alt mr-1"></i>Reserva
                                </h5>
                                <div class="col-8 mb-0">
                                    <!-- <b-form-group label="Agencia"> -->
                                    <b-form-select v-model="reserva.age" class="mb-1 bg-combo" :options="agencias"
                                        value-field="id" text-field="name" />
                                    <!-- </b-form-group> -->
                                </div>
                                <div class="col-1">
                                    <b-link v-b-modal.infoReservar v-b-tooltip.hover title="Información como Reservar">
                                        <h4><i class="fa fa-info-circle"></i></h4>
                                    </b-link>
                                </div>

                            </div>


                            <!-- Login -->
                            <div v-if="!logueado">
                                <div class="card p-3 my-3 bg-light-2">
                                    <p class="small">Si ya está registrado, inicie sesión para autocompletar sus datos
                                        personales, si es un nuevo usuario regístrese para continuar con la reserva.</p>
                                    <div>
                                        <!-- <b-link to="/login" class="mr-5 btn btn-outline-primary">Acceso Usuarios</b-link> -->
                                        <!-- <b-link to="/registro" class="mr-5 btn btn-outline-primary">Registrarme</b-link>                                     -->
                                        <b-btn @click="login_modal" class="mr-5" variant="outline-primary">Acceso
                                            Usuarios</b-btn>
                                        <b-btn @click="registro_modal" class="mr-5"
                                            variant="outline-primary">Registrarme</b-btn>

                                    </div>
                                </div>
                            </div>
                            <!-- Datos Reserva -->
                            <div v-else>
                                <!-- {{ R }} -->
                                <!-- Expedientes -->
                                <div class="form-row">
                                    <!-- c1 -->
                                    <b-form-group label="Expediente/s" class="col-2">
                                        <!-- <b-input-group size="sm">
                                            <b-input-group-prepend is-text>
                                                <b-link @click="buscaExped"><b-icon icon="search"></b-icon></b-link>
                                            </b-input-group-prepend>
                                            <b-form-input v-model="R.exp" label="Expediente" required readonly />
                                        </b-input-group> -->
                                        <b-btn size="md" variant="info" class="p-1 btn-block" @click="buscaExped"
                                            v-b-tooltip.hover title="Busqueda Expediente Clientes">
                                            <b-icon icon="search" class="mr-1"></b-icon>{{R.exp}}
                                            <!-- <b-badge variant="info" class="mr-1">{{R.exp}}</b-badge> -->
                                        </b-btn>
                                    </b-form-group>
                                    <!-- </div> -->
                                    <b-form-group label="Apellidos, Nombre" class="col-7">
                                        <b-form-input v-model="R.n1" v-uppercase trim required readonly />
                                    </b-form-group>
                                    <b-form-group label="DNI/NIF" class="col-3">
                                        <b-form-input v-model="R.d1" ref='dni' required trim @blur="valida_dni(R.d1)" readonly />
                                    </b-form-group>
                                </div>
                                <!-- c2 -->
                                <div class="form-row">
                                    <div class="col-2">
                                        <b-btn size="md" variant="info" class="p-1 btn-block" v-if="R.exp2>0 || (R.pax==1 && R.ind=='0')"
                                            v-b-tooltip.hover title="Busqueda Expediente Clientes"
                                            @click="buscaExped(2)">
                                            <b-icon icon="search" class="mr-1"></b-icon>{{R.exp2}}
                                            <!-- <b-badge variant="info" class="mr-1">{{R.exp}}</b-badge> -->
                                        </b-btn>
                                        <!-- <b-input-group size="sm" v-if="R.exp2>0 || (R.pax==1 && R.ind=='0')">
                                            <b-input-group-prepend is-text>
                                                <b-link @click="buscaExped(2)"
                                                    :readonly="reserva.exp > 0 && reserva.pax > 1">
                                                    <b-icon icon="search"></b-icon>
                                                </b-link>
                                            </b-input-group-prepend>
                                            <b-form-input v-model="R.exp2" required readonly />
                                        </b-input-group> -->
                                    </div>
                                    <b-form-group class="col-7">
                                        <b-form-input v-model="R.n2" v-uppercase required trim readonly />
                                    </b-form-group>
                                    <b-form-group class="col-3">
                                        <b-form-input v-model="R.d2" ref='dni' required trim readonly />
                                    </b-form-group>
                                </div>
                                <!-- c3 -->
                                <div class="form-row">
                                    <div class="col-2">
                                        <b-btn size="md" variant="info" class="p-1 btn-block"  v-if="R.exp3>'' || (R.pax==2 && R.exp2>'')"
                                            v-b-tooltip.hover title="Busqueda Expediente Clientes"
                                            @click="buscaExped(3)">
                                            <b-icon icon="search" class="mr-1"></b-icon>{{R.exp3}}
                                        </b-btn>
                                    </div>
                                        <b-form-group class="col-7" v-if="R.pax==3">
                                            <b-form-input v-model="R.n3" v-uppercase required trim readonly />
                                        </b-form-group>
                                        <b-form-group class="col-3" v-if="R.pax==3">
                                            <b-form-input v-model="R.d3" ref='dni' required trim readonly />
                                        </b-form-group>
                                </div>
                                <hr>

                                <!-- Localidad Residencia  -->
                                <div class="form-row">
                                    <b-form-group label="Localidad de Residencia" class="col-sm-7">
                                        <b-form-input v-model="R.pob" v-uppercase required trim readonly></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="Provincia" class="col-sm-5">
                                        <b-form-input v-model="R.pro" v-uppercase trim readonly></b-form-input>
                                    </b-form-group>
                                </div>
                                <!-- Telefonos  -->
                                <div class="form-row">
                                    <b-form-group label="Teléfono/s" class="col-sm-3">
                                        <b-form-input v-model="R.tf1" v-uppercase required trim></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="(2)" class="col-sm-3">
                                        <b-form-input v-model="R.tf2" v-uppercase trim></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="Email" class="col-sm-6">
                                        <b-form-input v-model="R.ema" v-uppercase trim></b-form-input>
                                    </b-form-group>
                                </div>
                                <hr>

                                <!-- <pre>{{  R }}</pre> -->

                                <!-- Expedientes -->
                                <div class="data-travel">

                                    <div class="form-group row">
                                        <!-- Info Disponibilidad -->
                                        <div class="col-3">
                                            <b-btn @click="hotelDispo" size='sm' class="mr-2"
                                                v-b-tooltip.hover title="Busqueda Establecimiento y Periodo"
                                                variant="outline-primary" >Disponibilidad
                                            </b-btn>
                                            <!-- <b-link v-b-modal.infoDispo>
                                                <i class="fa fa-info-circle fa-2x"></i>
                                            </b-link> -->
                                        </div>
                                        <!-- Combos Transporte, Pax, Tipo Habitación -->
                                        <div class="col-3">
                                            <b-form-select v-model="R.tra" :options="tptra" @change="calcula"
                                                class="form-control" />
                                        </div>
                                        <!-- <div class="col-2">
                                            <b-form-select v-model="reserva.tpp" :options="tppax" @change="calcula" class="form-control" disabled/>
                                        </div> -->
                                        <div class="col-3">
                                            <b-form-select v-model="R.tph" :options="tphab" @change="calcula"
                                                class="form-control" disabled />
                                        </div>
                                        <div class="col-3">
                                            <b-form-checkbox v-model="R.ind" :disabled="R.pax!=1" value="1" unchecked-value="0">
                                                Uso INDIVIDUAL<br> <small>(Añade Suplemento)</small>
                                                <!-- <router-link to="/politica" class="pl-2 pt-0"> Política de Privacidad</router-link> -->
                                            </b-form-checkbox>
                                        </div>

                                    </div>
                                    <!-- hotel -->
                                    <!-- {{  turno }} -->
                                    <div class="form-group row bg-hotel font-weight-bold">
                                        <b-form-group label="Hotel / Establecimiento" class="col-9 px-1">
                                            <b-form-input v-model="establecimiento" v-uppercase disabled />
                                        </b-form-group>
                                        <b-form-group label="Periodo - Noches" class="px-0 col-3">
                                            <b-form-input v-model="periodo" v-uppercase disabled />
                                        </b-form-group>
                                    </div>
                                </div>
                                <!-- <hr> -->
                                <!-- Observaciones  -->
                                <div class="form-group">
                                    <label for="observations" class="col-sm-3 col-form-label pt-0">Observaciones</label>
                                    <textarea class="form-control pt-0" cols="30" rows="3" v-model="R.obs" />
                                </div>
                                <!--Reservar-->
                                <div class="form-inline pt-1">
                                    <b-form-checkbox v-model="R.chk">Acepta
                                        <router-link to="/politica" class="pl-2 pt-0"> Política de Privacidad</router-link>
                                    </b-form-checkbox>

                                    <b-button type="submit" variant="primary"
                                        class="ml-auto my-3 my-sm-0 px-5">RESERVAR</b-button>

                                </div>
                                <div>
                                    <b-form-invalid-feedback :state="!chk_selected">
                                        <b-alert variant="danger" show>Debes Aceptar Politica de Privacidad</b-alert>
                                    </b-form-invalid-feedback>
                                </div>
                            </div>
                        </b-form>
                        <div class="info-rgpd p-2 mt-3">
                            <p><small>
                                    <strong>INFORMACIÓN BÁSICA SOBRE PROTECCIÓN DE DATOS</strong> <br>
                                    <strong>Responsable:</strong> VIAJES CEMO S.A.
                                    <strong>Finalidad:</strong> Gestionar la solicitud de reserva que realizas en este
                                    formulario. <br>
                                    <strong>Legitimación:</strong> Consentimiento del interesado. <br>
                                    <strong>DESTINATARIOS:</strong> No se cederán a terceros salvo obligación legal.
                                    <br>
                                    <strong>DERECHOS:</strong> Puedes ejercitar en cualquier momento tus derechos de
                                    acceso, rectificación, supresión, oposición y demás derechos legalmente establecidos
                                    a través del siguiente e-mail: info@viajescemo.com. <br>
                                    <strong>INFORMACIÓN ADICIONAL:</strong> Puedes consultar la información adicional y
                                    detallada sobre protección de datos
                                    <router-link to="/politica">aquí.</router-link>
                                    <!-- <a href="/politica">aquí.</a> -->
                                </small>
                            </p>
                        </div>
                    </div>
                </div>

                <!-- (derecha) info viaje -->

                <!-- Resumen Reserva -->
                <aside class="col-md-4">
                    <div class="card">
                        <div class="card-body">
                            <span class="h7 text-bold card-title pl-2 pt-2">{{ turno.hotel }}</span>
                            <!-- <img class="img-fluid m-0" :src="imgUrl()"> -->
                        </div>
                        <!-- <h5 class="card-header list-group-item-primary"><i class="fas fa-list-alt"></i> Resumen</h5> -->
                        <div class="p-2 text-right list-group-item-primary">
                            <!-- <div class="col-1">
                                <b-link @click="ayuda(1)">
                                    <i class="fa fa-info-circle fa-2x"></i>
                                </b-link>
                            </div> -->
                            <!-- <b-button class="mr-3" variant="outline-primary"
                            v-b-modal.modal_precios>Turnos y Precios</b-button> -->
                            <!-- <b-button class="mr-3" variant="outline-primary" @click="hotelPrecios_modal">Turnos y Precios</b-button> -->
                            <!-- Total a Pagar: -->
                            <span class="h3 m-2">{{ R.xtot }} €</span>
                        </div>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item">
                                Fecha Salida: <strong>{{ R.fhe | fecha }} </strong><br>
                                Regreso: <strong>{{ R.fhs | fecha  }}</strong> <br>
                                Duración: <strong>{{ xdiasnoc }}</strong></li>
                            <!-- <li class="list-group-item">Duración: <strong>{{ xdiasnoc }}</strong></li> -->
                            <li class="list-group-item">Pasajeros: <strong>{{ R.pax + ' (' + xTpp + ')' }}
                                </strong></li>
                            <li class="list-group-item">
                                Precio x Persona: <strong>{{ turno.pre }} €</strong><br>
                                Sup.Indiv.: <strong>{{ turno.sup }} €</strong>
                            </li>
                        </ul>

                        <ul class="list-group list-group-flush pt-1">
                            <li class="list-group-item list-group-item-primary"><span class="pr-2">
                                    <i class="fas fa-bed"></i></span>Establecimiento</li>
                            <li class="list-group-item"> Habitación: <strong>{{ R.xtph }}</strong>
                                <span class="ml-2" v-show="R.pax == 1">Uso individual</span>
                                <span class="ml-2" v-show="R.pax >= 3">(Triple)</span>
                            </li>
                        </ul>
                        <ul class="list-group list-group-flush pt-2">
                            <li class="list-group-item list-group-item-primary"><span class="pr-2">
                                    <i class="fas fa-utensils"></i></span>Servicios</li>
                            <li class="list-group-item"> <strong>{{ R.xreg }}</strong>
                                <p class="mb-0">
                                    <span class="d-table-cell font-italic"> - Primer servicio:</span>
                                    <span class="d-table-cell text-bold pl-2">{{ turno.xent }}</span>
                                </p>
                                <p class="mb-0">
                                    <span class="d-table-cell font-italic"> - Último servicio:</span>
                                    <span class="d-table-cell text-bold pl-2">{{ turno.xsal }}</span>
                                </p>
                            </li>
                            <!-- <li class="list-group-item">
                                <p class="mt-2 mb-0">
                                    <span class="d-table-cell font-italic"> - Incluido:</span>
                                    <span class="d-table-cell  font-weight-bold pl-2">{{ turno.desIN }}</span>
                                </p>
                                <p class="mt-1 mb-0">
                                    <span class="d-table-cell  font-italic"> - No incluido:</span>
                                    <span class="d-table-cell font-weight-bold pl-2">{{ turno.desNO }}</span>
                                </p>
                            </li> -->

                        </ul>
                        <ul class="list-group list-group-flush pt-2">
                            <li class="list-group-item list-group-item-primary"><span class="pr-2"><i
                                        class="fas fa-bus"></i></span>Transporte</li>
                            <li class="h8 list-group-item"> <strong>{{ turno.lug1 }}</strong><br>Hora:<strong>{{ turno.hora1}}</strong></li>
                        </ul>
                        <!-- imagen -->
                        <img class="img-fluid m-0" :src="imgUrl()">
                        <hr>

                    </div>
                </aside>
            </div>

        </div>

        <!-- Modal infoReservar -->
        <b-modal id="infoReservar" class="modal-dialog modal-lg modal-dialog-centered" ok-only title="AYUDA - Reservar">

            <div class="m-3 p-3 border border-info">
                <ol class="p-3">
                    <li>Seleccione Clientes.</li>
                    <li>Pulse Busqueda (lupa) de Expedientes, donde puede buscar por el número de expediente o el DNI del cliente.</li>
                    <li>En caso de Expediente de una persona, existen dos opciones, por omisión uso INDIVIDUAL (precio incrementado por un suplemento) <br>* Pulse check <b>Uso individual</b> para convertirla en DOBLE ó TRIPLE COMPARTIDA.<br>* Ahora puede seleccionar (lupa) otros dos expedientes como máximo de una persona para convertirla en DOBLE ó TRIPLE (compartida) ó dejarla para despues su compartida de forma aleatoria.</li>
                    <li>Seleccione la Ruta o Estancia en hotel que desea reservar pulsando botón DISPONIBILIDAD.<br>Le apareceran los distintos establecimientos con sus periodos</li>
                    <li>Seleccione la fecha de salida deseada con plazas disponibles.</li>
                    <li>Importante !! debe confirmar el télefono móvil y un email válido para poder contactar.</li>
                    <li>Puede introducir Observaciones de la reserva.</li>
                </ol>
            </div>
        </b-modal>

        <!-- Modal infoDispo -->
        <b-modal id="infoDispo" class="modal-dialog modal-lg modal-dialog-centered" ok-only
            title="AYUDA - Disponibilidad">

            <div class="m-3 p-3 border border-info">
                <ol class="p-3">
                    <li>Seleccione la Ruta o Estancia en hotel que desea reservar.</li>
                    <li>Seleccione la fecha de salida con plazas disponibles.</li>
                    <li>Selecciona el número de personas. </li>
                    <li>Regístrese o inicie sesión con su usuario y contraseña</li>
                    <li>Importante el télefono móvil y un email válido para poder
                        localizarle.
                    </li>
                </ol>
            </div>
        </b-modal>


        <!-- Modal Login -->
        <!-- <hotelPrecios/> -->

    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

// import MenuOpcion from '@/components/MenuOpcion.vue'
//import hotelPrecios from '@/components/HotelPrecios.vue'
//import reservaInfo from '@/components/reservaInfo.vue'

export default {
    name: 'reserva',
    components: {
        // MenuOpcion,

        //hotelPrecios,
    },
    data() {
        return {
            modulo: 'Reservas',
            titulo: 'RESERVAR',

            submitted: false,

            //agencias: [],
            tptra: [
                { value: '1', text: 'Transporte' },
                { value: '0', text: 'Sin Transporte' },
            ],
            tppax: [
                { value: '10', id: '1A', text: '1 Adu', pax: 1 },
                { value: '20', id: '2A', text: '2 Adu', pax: 2 },
                { value: '30', id: '3A', text: '3 Adu', pax: 3 },
            ],
            tphab: [
                { value: '1', id: '1A', text: 'INDIVIDUAL', pax: 1 },
                { value: '2', id: '2A', text: 'DOBLE.COMP', pax: 2 },
                { value: '3', id: '2A', text: 'DOBLE', pax: 2 },
                { value: '4', id: '3A', text: 'TRIPLE', pax: 3 },
            ],

            regimen: { A:'Solo Alojamiento',AD:'Alojamiento y Desayuno',MP:'Media Pensión',PC:'Pensión Completa'},
            servicios: { D:'Desayuno',A:'Almuerzo',C:'Cena' },
        }
    },

    computed: {
        ...mapState(['G', 'auth', 'errores', 'reserva']),

        logueado() {
            return this.auth.logueado;
        },
        cta() {
            return this.auth.user;
        },
        agencias() {
            return this.$store.state.agencias;
        },
        hotel() {
            return this.$store.state.hoteles.hotel;
        },
        /* turnos() {
            return this.$store.state.hoteles.turnos.items;
        }, */
        turno() {
            let T=this.$store.state.hoteles.turno;
            T.xent=this.servicios[T.ent1];
            T.xsal=this.servicios[T.sal1];

            return T;
        },
        exped() {
            return this.$store.state.exped.items[0] || [];
        },
        establecimiento() {
            //return this.hotel.hotel;
            return this.turno.hotel ;
        },
        periodo() {
            let T = this.turno;
            if (!T.fhe) return "";
            let fhe=T.fhe.split('-').reverse().join('/');
            let fhs=T.fhs.split('-').reverse().join('/');
            return (!T.fhe ? '' : fhe.substr(0, 5) + ' · ' + fhs + ' ( ' + T.noc + ' )');
        },
        // servicio
        xTpp() {
            let P=this.R.tpp.split('');
            let X=(P[0]>0?P[0]+ ' Adulto' + (P[0]>1?'s':''):'') +
                (P[1]>0?P[1]+ ' Niño' + (P[1]>1?'s':''):'');
            return X;
        },
        xdiasnoc() {
            return !this.turno.noc ? '' : String(Number(this.turno.noc) + 1) + " dias " + String(this.turno.noc) + " noches";
        },
        xTph() {
            return "Habitación Doble";
        },
        xReg() {
            return this.regimen[this.turno.reg];
        },
        IMP() {
            return {
                pre: this.$util.SN(this.turno.pre), supi: this.$util.SN(this.turno.supi)
                , d1n: this.$util.SN(this.turno.d1n), d2n: this.$util.SN(this.turno.d2n)
                , d3p: this.$util.SN(this.turno.d3p), d4P: this.$util.SN(this.turno.d4p)
                , seg: [0, this.$util.SN(this.turno.segA), this.$util.SN(this.turno.segC)],
            };
        },

        R() {
            let r = this.reserva;

            //r.pax = (r.d3 > '' ? 3 : (r.d2 > '' ? 2 : 1)) || 0;
            r.tph=(r.pax==3?4:(r.pax==2?3:(r.ind=='1'?1:2)));
            r.xtph=r.tph<'1' && r.tph>'4' ? '' : this.tphab[r.tph-1].text;
            r.tpp=String(r.pax) + '0';
            r.xreg=this.regimen[r.reg] || '';
            r.xtra=(r.tra=='0'?'SIN TRANSPORTE':'BUS')
            //calculos
            r.pre = this.turno.pre || 0;
            r.sup = r.ind=='0' ? 0 : Number(this.turno.sup);
            r.tot = (Number(r.pre * r.pax) + r.sup) || 0 ;
            r.xtot =this.$util.NS(r.tot)
            r.com = Number(r.pax * this.turno.com) || 0;
            r.pag = Number(r.tot) - Number(r.com) || 0;

            return r;
        },

        chk_selected() {
            return this.submitted && !this.reserva.chk;
        }
    },

    created() {
        //console.log('*reservar.created',this.hotel.hot,this.hotel.imagenes,this.turno.id);
    },
    mounted() {
        //turno seleccionado
        this.seleccionado();

        //datos omision cliente
        //this.datos_cuenta(this.cta);

        // agencia omision la primera
        this.reserva.age = this.agencias[0].id;
    },

    watch: {
        reserva: {
            handler: function (val) {
                console.log("* reservar.reserva", val);
            },
            deep: true
        },
        //turno (item , old) {
        turno() {
            //this.seleccionado();
        },
        /* cta(item) {
            this.datos_cuenta(item);
        }, */


    },
    methods: {
        ...mapMutations(['loading', 'alerta', 'modal', 'showModal', 'hideModal']),
        ...mapActions(['exec','error']),

        async submit(evt) {
            console.log('** submit', evt)
            evt.preventDefault();
            this.submitted = true;

            if (!this.reserva.chk) return;
            //validar dnis y demas datos ???
            if (!this.validar()) return;

            //Preguntarº1
            let msg = "Estas seguro <b>RESERVA</b> ?<hr>" +
                `Hotel: <b>${this.turno.hotel}</b><br>Periodo: <b>${this.turno.periodo}</b> (${this.turno.noc} Noches)<br>` +
                `Personas: <b>${this.R.pax}</b> - Hab: <b>${this.R.xtph}</b><br>` +
                `<small>Cliente/s:<br><b>${this.R.n1}<br>${this.R.n2}<br>${this.R.n3}</small></b><hr>` +
                `<small>Transporte:</small> <b>${this.R.xtra}</b><hr>` +
                `Importe: <b>${this.R.xtot}</b> €<br><hr>` +
                "<small>Tras ACEPTAR la Reserva se mostrará una ventana con el Localizador de la Reserva e impresión de la misma. También puede dirigirse al Apartado de Reservas, dentro de ACCESO para resto de gestiones.<br> " +
                "<i><b>Aseguresé que su navegador permite ventanas emergentes</i></b>.</small>"

            if (!await this.$root.$msgConf(msg, 'RESERVA')) return;

            this.enviar();
        },

        validar() {
            let R = this.reserva;
            let m = '';
            if (!R.exp)  m = "Debes Pulsar Busqueda de Expediente"; else
            if (!R.hot)  m = "Debes Pulsar Disponibilidad para Busqueda del Establecimiento"; else
            if (R.tf1.length < 9 || !(String(R.tf1).charAt(0)>='6' && String(R.tf1).charAt(0)<='9'))
                m = "Debes Introducir un Teléfono Valido del CLIENTE para la gestión de la Reserva";
            if (R.tf2>'' && (R.tf2.length < 9 || !(String(R.tf2).charAt(0)>='6' && String(R.tf2).charAt(0)<='9')))
                m = "Debes Introducir un Teléfono (2) Válido";

            if (m > '') this.modal({ tit: this.modulo, msg: m, time: 0 });
            return (m == '');
        },

        async enviar() {
            this.loading();
            let arg = { ...this.reserva, token: this.auth.token };          //token y reserva
            let r = await this.exec({ api: 'reservar', arg });
            this.loading(false);

            if (await this.error({ r })) return;

            /* //this.submitted = false;
            //let m = (r.error ? r.msg : 'Petición/Reserva Nº ' + r.r[0] + 'guardada correctamente');
            if (r.error) {
                this.modal({ tit: this.modulo, msg: r.msg }); //, time:0});
                return;
            } */

            //inicializamos reserva
            await this.inicializaReserva();

            // cargamos reserva y la mostramos
            this.$store.state.iReserva=r.r[0];
            await this.reservaInfo();

        },

        async inicializaReserva() {
            this.$store.state.reserva= {
                id: 0,exp:'',exp2:'',exp3:'',
                d1:'',n1:'',d2:'',n2:'',d3:'',n3:'',d4:'',n4:'',
                pob:'',pro:'',tf1:'',tf2:'',ema: '',
                pax:0,tpp:'00',tph:'3',ind:0,
                tra:1,seg:0,obs:'',
                //hot:0, fhe:'',fhs:'',noc:0,reg:'PC',turno:0,
                //pre:0,sup:0,com:0,tot:0,pag:0,
                chk: false,
            }
            // dejamos age y datos del turno
            //this.$store.state.hoteles.turno = {};
        },

        async reservaInfo() {
            this.$bvModal.show("modal_reservaInfo");
            //await this.$root.$reservaInfo();
        },

        async msgBanco(r) {

            this.pagoBanco();

            let msg = r.error ? r.datos :
                '<span class="text-justify">' +
                'Su Petición de Reserva Nº <b>' + this.reserva.id + '</b> se ha generado correctamente.<br><br>' +
                'Se ha procedido al pago con tarjeta de credito de <h3>' + this.reserva.tot + ' €</h3><br>' +
                'En este proceso se ha abierto una nueva ventana de nuestro banco donde le solicitara de forma segura los datos de pago.<br>' +
                'En caso de no finalizar el proceso lo podra volver a iniciar en el apartado de reservas de la información personal, la petición de reserva tiene una caducidad de 30 minutos para activar de nuevo el proceso de pago.<br><br>' +
                'Si completa el proceso, ya dispondrá de su/s bonos correspondientes para los servicios contratados.<br>' +
                '<b><i>Importante:</b></i><br><small>Asegurese que su navegador permite ventanas emergentes (popup).</small>' +
                '</span>';
            //this.modal({tit:"Reserva", msg:msg,time:0});

            await this.$root.$msgBox(msg, this.modulo);

            //this.loading(false);
            //this.$router.push('/');
        },

        pagoBanco() {
            let url = this.G.url_tpv;
            let arg = new Date().getTime() + '|5.' + this.reserva.id + '|' + this.reserva.tot;

            window.open(url + '?w=' + arg, "_blank");

        },


        //////////////////////////////////////////
        login_modal_store() {
            this.$store.commit("showModal", 'Login');
        },
        login_modal() {
            this.$bvModal.show("modal_login");
        },
        registro_modal() {
            this.$bvModal.show("modal_registro");
        },
        hotelPrecios_modal() {
            this.$root.$hotelPrecios();
            //this.$bvModal.show("modal_hotelPrecios");
        },

        // imagenes datos hotel-turno
        imgUrl() {
            if (!this.hotel.imagen) return "";
            return (this.hotel.imagen[0] ? this.$store.state.G.urlTMP + this.hotel.imagen[0] : '');
        },

        /* imgUrl0(){
            let url=this.G.url_img+"?w=123|vc_agencias|hoteles_img|||"+this.hotel.hot;
            return url;
        }, */

        // turno seleccionado
        seleccionado() {
            this.reserva.turno = this.turno.id;
            //this.tipopax();
            //this.tiposeg();
            //this.salidas();
            //calculamos reserva
            //this.calcula();

            //datos cuenta
            //if (this.cta.ape != this.reserva.c1.ape) this.datos_cuenta(this.cta);
            //console.log("* reservar.seleccionado",this.reserva,this.tppax,this.tpseg);
        },
        tipopax() {
            //this.turno.tpp='0013';
            if (!this.turno.tpp) this.turno.tpp = "0022";
            let p = this.turno.tpp.split('');

            let min = p[0]; if (min == undefined || min == 0) min = 0;
            let max = p[1]; if (max == undefined || max == 0) max = 0;
            let minA = p[2]; if (minA == undefined || minA == 0 || minA < min) minA = min;
            let maxA = p[3]; if (maxA == undefined || maxA == 0 || maxA < max) maxA = max;

            this.tppax = [];
            for (let i = minA; i <= maxA; i++) {
                let pp = i + 'A';
                let ppp = i + ' Adulto' + (i > 1 ? 's' : '');
                this.tppax.push({ id: pp, value: String(i * 10), text: ppp, pax: i });

                for (let j = 1; j < max; j++) {
                    let s = Number(i) + Number(j);
                    if (s > max) continue;
                    let nn = j + 'N';
                    let nnn = j + ' Niño' + (j > 1 ? 's' : '');
                    this.tppax.push({ id: pp + nn, value: String(i * 10 + j), text: ppp + " " + nnn, pax: s });
                }
            }
        },
        tiposeg() {
            this.tpseg = [{ value: 0, text: 'Selecciona Opción (Precio x Persona) ' }];
            if (this.$util.SN(this.turno.segA) > 0)
                this.tpseg.push({ value: 1, text: "Seguro de Anulación (" + this.turno.segA + " €)" });
            if (this.$util.SN(this.turno.segC) > 0)
                this.tpseg.push({ value: 2, text: "Seguro Asistencia Plus + Anulación (" + this.turno.segC + " €)" });
            //extras ??

        },
        salidas() {
            /* console.log('*************reservar.salidas',this.turno.sal);
            if (this.turno.sal=='*SIN TRANSPORTE') {
                this.reserva.tra=this.reserva.lsa=0;
                this.tpsal=[{value:0, text: "" }];
                return;
            }
            this.reserva.tra=this.reserva.lsa=1;
            let S=this.turno.salidas.split('\r\n');
            let i=1; let A=[]
            S.forEach(function(item) {
                if (item!='') {
                    console.log(item);
                    A.push({value: i, text: item + ' - ' + i });
                    i++;
                }
            });
            this.tpsal=A;
            //for (let i=1;j<max;j++) {

            console.log('*************reservar.salidas',S,i,this.tpsal); */
        },
        // calculo reserva
        // lo sustituimos por  R en computed
        calcula() {
            /* let adu = Number(this.reserva.tpp.charAt(0));
            let nin = Number(this.reserva.tpp.charAt(1));
            let pax = adu + nin;
            let P = this.IMP;
            let sup = 0;
            let dto = 0;
            let ext = 0;
            let imp = pax * P.pre;

            //suplementos
            if (pax == 1 && P.supi > 0) sup += P.supi;  //individual

            //descuentos
            if (nin > 0 && P.d1n != 0) dto += (P.d1n < 0 ? this.$util.round((-P.d1n) * P.pre / 100) : P.d1n);
            if (nin > 1 && P.d2n != 0) dto += (P.d2n < 0 ? this.$util.round((-P.d2n) * P.pre / 100) : P.d2n) * (nin - 1);
            if (adu > 2 && P.d3p != 0) dto += (P.d3p < 0 ? this.$util.round((-P.d3p) * P.pre / 100) : P.d3p);
            if (adu > 3 && P.d4p != 0) dto += (P.d4p < 0 ? this.$util.round((-P.d4p) * P.pre / 100) : P.d4p) * (adu - 3);

            //seguro
            if (this.reserva.seg > 0) ext += pax * P.seg[this.reserva.seg];
            //extras

            this.reserva.pax = pax;
            this.reserva.tot = imp + sup - dto + ext;
            //console.log('* reservar.calcula',pax,this.reserva); */
        },

        datos_cuenta(C) {
            console.log(C);
            /* this.reserva.c1 = {
                sra: C.sra, ape: C.ape, nom: C.nom, nif: C.nif, nac: C.nac, cpo: C.cpo,
            };
            this.reserva.pob = C.pob; this.reserva.pro = C.pro;
            this.reserva.ema = C.email;
            this.reserva.tfn = C.tfno; */
        },

        //validar (pasarlo a utilidades)
        valida_dni(dni) {
            console.log(dni);
            return true;
            /* let r=this.$util.validaCIF(dni);
            if (!r) {
                //this.$refs.dni.focus();
                alert('CIF Invalido ' + r);
            } */
        },

        //
        ayuda(p = 0) {
            console.log(p);
            /* var tit="Ayuda";
            var msg='';
            if (p==1) msg="Hola <b>Capullo</b><br>Adiossss";
            this.$root.$toast(msg,tit); */
        },

        //
        // async hotel_precios() {
        //await this.$store.dispatch('hotel_precios',this.hotel);
        buscaExped(tp=1) {
            //grabamos que opcion usamos

            this.$store.state.exped.busca=tp;

            this.$bvModal.show("modal_buscaExped");
        },
        async hotelDispo() {
            //this.$bvModal.show("modal_hotelDispo");
            await this.$root.$hotelDispo();
        },
    }

}
</script>